$(document).ready(function () {
  var checkBanner = setInterval(function () {
    var banner = $(".pd-cookie-banner-window");

    // Check if element exists and is visible
    if (banner.length && banner.is(":visible")) {
      // Stop the interval
      clearInterval(checkBanner);

      // Your logic
      var imgUrl = "https://cdn.shopify.com/s/files/1/0633/4706/5062/files/Group_1000001970.png?v=1744193326";
      var imgElement = $("<img>")
        .attr("src", imgUrl)
        .attr("alt", "Cookies Banner Image");

      $(".cc-logo").prepend(imgElement);
      banner.css("display", "block");
    }
  }, 100); // Check every 100 milliseconds
});

